import * as types from '../actions/actionTypes'
import * as loadMoreReducerHelper from '../libs/loadMoreReducerHelper'

export const initialState = {
  list: loadMoreReducerHelper.createInitialState(), // requestGetSellerHistories result
  items: {}, // key = itemId, value = requestGetSellerHistoryDetail result
  periods: {}, // key = periodId, value = requestGetInstalmentHistories result
}

/*
  list.items[0] example: {
    "cream_item_id": "237156063a9f3c94d3adf714e44213759c631d0bb6d78f3a6013c870", // 商品ID
    "title": "團購名稱",
    "instalment": 6,     // 分期期數
    "receive_count": 1,  // 已收款數量 (包含分期第一期)
    "status": "created", // created (開放中); terminated (已停止收款); receiving (分期收款中); completed (已結束)
    "create_stamp": "2020-07-14T03:41:04.000Z" // 團購開始日期 (UTC)
  }

  items[itemId] example: {
    receive_count: 1,
    exchange_rate: 31,
    orders: {
      items: [], // actual orders
      isFetching: false,
      hasMore: true,
      fetchedTimes: 1,
    },
    info: {},
  }
 */

export default function sellerHistoryReducer(
  sellerHistory = initialState,
  action,
) {
  const { list, items } = sellerHistory
  const { payload } = action
  switch (action.type) {
    case types.GET_SELLER_HISTORIES:
      return {
        ...sellerHistory,
        list: loadMoreReducerHelper.onStartFetching(list),
      }
    case types.GET_SELLER_HISTORIES_SUCCESS:
      return {
        ...sellerHistory,
        list: loadMoreReducerHelper.onFetchSuccess(
          list,
          payload.items,
          payload.replace,
        ),
      }
    case types.GET_SELLER_HISTORIES_ERROR:
      return {
        ...sellerHistory,
        list: loadMoreReducerHelper.onFetchError(list),
      }
    case types.GET_SELLER_HISTORY_DETAIL: {
      const { itemId } = payload
      const oldItem = items[itemId] || {}
      return {
        ...sellerHistory,
        items: {
          ...items,
          [itemId]: {
            ...oldItem,
            orders: loadMoreReducerHelper.onStartFetching(oldItem.orders),
          },
        },
      }
    }
    case types.GET_SELLER_HISTORY_DETAIL_SUCCESS: {
      const { itemId, data } = payload
      const oldItem = items[itemId]
      const newSingleItem = { receive_count: data.receive_count }

      if (data.info) {
        newSingleItem.status = data.info.status
      }
      return {
        ...sellerHistory,
        list: loadMoreReducerHelper.updateSingleItem(
          list,
          newSingleItem,
          item => item.cream_item_id === itemId,
        ),
        items: {
          ...items,
          [itemId]: {
            exchange_rate: data.exchange_rate ?? oldItem.exchange_rate,
            info: data.info ?? oldItem.info,
            receive_count: data.receive_count ?? oldItem.receive_count,
            orders: loadMoreReducerHelper.onFetchSuccess(
              oldItem.orders,
              data.orders,
              payload.replace,
            ),
          },
        },
      }
    }
    case types.GET_SELLER_HISTORY_DETAIL_ERROR: {
      const { itemId } = payload
      const oldItem = items[itemId]
      return {
        ...sellerHistory,
        items: {
          ...items,
          [itemId]: {
            ...oldItem,
            orders: loadMoreReducerHelper.onFetchError(oldItem.orders),
          },
        },
      }
    }
    case types.GET_INSTALMENT_HISTORIES_SUCCESS:
      return {
        ...sellerHistory,
        periods: {
          ...sellerHistory.periods,
          [payload.periodId]: payload.data,
        },
      }
    case types.GET_INSTALMENT_HISTORIES_ERROR:
      return {
        ...sellerHistory,
        periods: {
          ...sellerHistory.periods,
          [payload.periodId]: null,
        },
      }
    case types.TERMINATE_CREAM_ITEM_SUCCESS: {
      // * update 2 items:
      // * 1. sellerHistory.list.items[terminatedItemIndex]
      // * 2. sellerHistory.items[itemId]
      const itemId = payload
      const oldItem = items[itemId]
      return {
        ...sellerHistory,
        list: loadMoreReducerHelper.updateSingleItem(
          list,
          {
            status: 'terminated',
          },
          item => item.cream_item_id === itemId,
        ),
        items: oldItem
          ? {
              ...items,
              [itemId]: {
                ...oldItem,
                info: {
                  ...oldItem.info,
                  status: 'terminated',
                },
              },
            }
          : items,
      }
    }
    case types.MOVE_CREATED_ITEM_TO_LIST:
      // * push createdCreamItem into list.items
      if (list.items[0]?.cream_item_id === payload.cream_item_id) {
        return sellerHistory
      }
      return {
        ...sellerHistory,
        list: {
          ...list,
          items: [payload, ...list.items],
        },
      }
    case types.MARK_CREATED_ITEM_SHOWN: {
      const item = list.items[0]
      if (item && item._created) {
        return {
          ...sellerHistory,
          list: loadMoreReducerHelper.updateSingleItem(
            list,
            {
              _animated: true,
            },
            (item, index) => index === 0,
          ),
        }
      }
      return sellerHistory
    }
    default:
      return sellerHistory
  }
}
